import React from 'react';
import { Modal, FormGroup, Col, Button } from 'react-bootstrap';
import './style.scss';

class DeleteModal extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        let oldName = this.props.prevRoleName;

        return (
            <div>
                <Modal show={this.props.showModal} size="sm" onHide={() => { this.props.toggleModal() }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm role delete: </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <div className="margin-bottom-10">
                            <h4>Do you want to delete {oldName}?</h4>
                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <FormGroup>
                            <Col smOffset={2} sm={10}>
                                <Button type="button" bsStyle="danger" onClick={this.props.confirmationDelete}>Confirm delete</Button>
                            </Col>
                        </FormGroup>
                    </Modal.Footer>
                </Modal>
            </div>
            
        )
    }
}

export default DeleteModal;